import PromoBanner from "../PromoBanner";
import TrialBanner from "../TrialBanner";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { getProctoringPassed } from "selectors/userInfo";
import { getCabinetPromoLectureWithoutSubscribeActionCreator } from "api/CabinetPromoApi";
import { MediaQueryContainer } from "containers";
import MobileCalendar from "../MobileCalendar";
import { PageTitle } from "shared";
import { MainContainerWrapper } from "./styledComponents";
import Progress from "../Progress";
import AuthStateCard from "../AuthStateCard/AuthStateCard";

const MainContainer = () => {
	const dispatch = useDispatch();
	const proctoringPassed = useSelector(getProctoringPassed);

	useEffect(() => {
		dispatch(getCabinetPromoLectureWithoutSubscribeActionCreator());
	}, [dispatch]);

	return (
		<MainContainerWrapper>
			<PageTitle>Мой Кабинет</PageTitle>
			<TrialBanner />
			{!!proctoringPassed && (
				<ProctoringPassedCard>
					✓ Экзамен с прокторингом сдан
				</ProctoringPassedCard>
			)}
			<AuthStateCard />
			<PromoBanner />
			<MediaQueryContainer maxWidth={1245}>
				<MobileCalendar />
			</MediaQueryContainer>
			<Progress />
		</MainContainerWrapper>
	);
};

export default MainContainer;

const ProctoringPassedCard = styled.div`
	background: #d4edda;
	color: #155724;
	padding: 16px 24px;
	border-radius: 12px;
	font-size: 1rem;
	font-weight: 600;
	text-align: center;
	border: 1px solid #c3e6cb;
	margin-bottom: 16px;
`;
